
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "diagnosis_of_severe_pre_eclampsia",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/diagnosis_of_severe_pre_eclampsia.vue